var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyChecklistHero5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#000;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10{stroke-miterlimit:10;}.cls-1,.cls-2,.cls-3,.cls-5{fill:none;}.cls-1,.cls-5,.cls-7,.cls-8{stroke-width:7.59px;}.cls-11{fill:#a7cbc1;}.cls-2{stroke-width:2.5px;}.cls-2,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10{stroke:#060910;}.cls-12{letter-spacing:-.02em;}.cls-13{letter-spacing:-.01em;}.cls-3{stroke:#dfefe9;stroke-width:7.58px;}.cls-4{stroke-width:4.13px;}.cls-4,.cls-5,.cls-9{stroke-linecap:round;}.cls-4,.cls-14,.cls-9,.cls-10{fill:#dfefe9;}.cls-15{font-family:FranklinGothic-Heavy, 'Franklin Gothic Heavy';font-size:27.92px;font-weight:800;}.cls-15,.cls-16,.cls-17{fill:#060910;}.cls-18{letter-spacing:-.03em;}.cls-16{font-family:Poppins-Bold, Poppins;font-size:28.95px;font-weight:700;}.cls-19{letter-spacing:0em;}.cls-6{stroke-width:5.04px;}.cls-6,.cls-8{fill:#f9b148;}.cls-20{letter-spacing:0em;}.cls-7{fill:#cc3636;}.cls-9{stroke-width:6.07px;}.cls-21{letter-spacing:-.01em;}.cls-22{fill:#5a9b5f;}.cls-10{stroke-width:8.67px;}.cls-23{letter-spacing:0em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 3000,
    height: 2000
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 101.45,
    y: 178.35,
    width: 2797.11,
    height: 1643.3,
    rx: 37.02,
    ry: 37.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m2325.34,1819.65H680.76c12.76-17.07,34.55-29.17,54.52-38.82,51.4-24.84,103.04-49.77,156.76-68.82,14.22-5.04,28.57-9.67,43.11-13.78,101.39-28.64,208.07-30.94,313.41-33.05,106.11-2.12,212.29-4.25,318.33-.24,147.09,5.55,294.34,23.2,438.02,55.27,109.43,24.43,216.78,57.23,320.41,99.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m1017.85,1819.65H148.97c-26.25,0-47.52-21.28-47.52-47.52v-272.79c10.38-.99,20.94-1.08,31.28-1.02,125.18.77,250.26,16.24,371.85,45.95,137,33.49,272.38,87.56,387.47,167.75,45.5,31.67,87.8,67.44,125.8,107.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m2898.55,1352.73v419.39c0,26.25-21.28,47.52-47.52,47.52h-936.89c.14-.15.26-.3.39-.46,29.15-33.76,59.2-66.95,90.4-98.99,78.82-80.88,164.99-154.33,262.55-210.63,189.84-109.55,410.38-147.53,631.08-156.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m891.35,1710.12c119.79-34.36,251.78-40.97,376.49-46.73,131.85-6.09,264.09-3.62,395.62,7.4,114.5,9.58,229.28,24.39,341.46,49.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m101.45,1499.33c10.38-.99,20.94-1.08,31.28-1.02,125.18.77,250.26,16.24,371.85,45.95,137,33.49,272.38,87.56,387.47,167.75,45.5,31.67,87.8,67.44,125.8,107.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1914.13,1819.65c.14-.15.26-.3.39-.46,29.15-33.76,59.2-66.95,90.4-98.99,78.82-80.88,164.99-154.33,262.55-210.63,189.84-109.55,410.38-147.53,631.08-156.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "2820.71 1442.15 2820.71 1295.2 2729.46 1203.96 2671.4 1203.96 2692.73 1203.96 2634.66 1203.96 2543.41 1295.2 2543.41 1442.15 2820.71 1442.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2603.16,
    y: 1311.5,
    width: 151.87,
    height: 122.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2679.1,
    y1: 1309.72,
    x2: 2679.1,
    y2: 1436.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2655.6,
    y: 1225.29,
    width: 48.98,
    height: 55.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2704.58,
    y1: 1225.29,
    x2: 2655.6,
    y2: 1280.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2655.6,
    y1: 1225.29,
    x2: 2704.58,
    y2: 1280.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2603.16,
    y1: 1311.5,
    x2: 2675.25,
    y2: 1431.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2603.16,
    y1: 1434.31,
    x2: 2676.73,
    y2: 1311.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2755.04,
    y1: 1311.5,
    x2: 2681.17,
    y2: 1434.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2755.04,
    y1: 1434.31,
    x2: 2680.29,
    y2: 1311.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1727.19,
    y: 1683.27,
    width: 9.43,
    height: 46.74,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1739.14,
    y: 1680.75,
    width: 9.43,
    height: 46.74,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1774.46,
    y: 1683.58,
    width: 9.43,
    height: 46.74,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1788.92,
    y: 1681.91,
    width: 9.43,
    height: 46.74,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1818.77,1671.01c-.09-1.69-.38-3.35-.85-4.97.85-2.16,1.33-4.51,1.33-6.97,0-10.53-8.54-19.07-19.07-19.07-1.14,0-2.25.12-3.33.31-1.36-9.2-9.26-16.27-18.84-16.27-6.9,0-12.93,3.68-16.27,9.17-2.79-1.59-6-2.52-9.44-2.52-7.96,0-14.77,4.88-17.63,11.81-2.34-1.03-4.93-1.61-7.65-1.61-10.53,0-19.07,8.54-19.07,19.07,0,4.37,1.48,8.38,3.96,11.6-5.55,3.33-9.28,9.39-9.28,16.34,0,10.53,8.54,19.07,19.07,19.07,4.49,0,8.61-1.56,11.87-4.16,3.16,6.15,9.56,10.37,16.95,10.37,6.19,0,11.68-2.97,15.16-7.54.12,0,.24,0,.35,0,.94,0,1.88-.02,2.81-.05,3.32,2.79,7.59,4.48,12.27,4.48,7.12,0,13.32-3.91,16.6-9.7,1.76.54,3.63.83,5.57.83,10.53,0,19.07-8.54,19.07-19.07,0-4.15-1.34-7.98-3.59-11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1762.38,1694.33s1.28,7.21,5.16,9.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1747.41,1677.7s-12.83-5.8-22.79,9.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1749.96,1651.06s.36,14.09,14.5,15.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1777.96,1686.98s14,1.58,17.59-12.19"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1807.12,
    cy: 1645.33,
    rx: 13.12,
    ry: 17.33,
    transform: "translate(-364.55 524.32) rotate(-15.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1792.73,
    cy: 1641.73,
    rx: 5.85,
    ry: 2.57,
    transform: "translate(-608.43 2020.67) rotate(-51.45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1812.56,
    cy: 1631.16,
    rx: 2.66,
    ry: 5.65,
    transform: "translate(-24.39 3234.8) rotate(-83.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 1803.08,
    cy: 1643.82,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 1816.01,
    cy: 1639.17,
    r: 1.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 390.33,
    y: 1656.78,
    width: 13.87,
    height: 68.76,
    rx: 2.7,
    ry: 2.7,
    transform: "translate(794.53 3382.31) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 372.76,
    y: 1653.08,
    width: 13.87,
    height: 68.76,
    rx: 2.7,
    ry: 2.7,
    transform: "translate(759.39 3374.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 316.49,
    y: 1655.39,
    width: 13.87,
    height: 68.76,
    rx: 2.7,
    ry: 2.7,
    transform: "translate(646.85 3379.54) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 294.6,
    y: 1656.62,
    width: 13.87,
    height: 68.76,
    rx: 2.7,
    ry: 2.7,
    transform: "translate(603.06 3382) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m251.74,1623.79c0-14.53,9.28-26.86,22.22-31.49,4.2-11.74,14.74-20.45,27.52-21.96,4.21-13.67,16.94-23.61,31.99-23.61,8.76,0,16.71,3.39,22.68,8.9,4.03-1.72,8.47-2.68,13.13-2.68,8.96,0,17.08,3.54,23.09,9.28,5.24-3.39,11.46-5.38,18.17-5.38,18.48,0,33.47,14.99,33.47,33.47,0,5.32-1.27,10.33-3.48,14.79.31.49.62.99.91,1.49,9.91,5.81,16.58,16.55,16.58,28.86,0,18.05-14.3,32.72-32.18,33.41-4.51,13.16-16.95,22.64-31.64,22.64-8.15,0-15.62-2.92-21.43-7.77-1.09.11-2.18.21-3.28.3-5.78,10.04-16.59,16.81-29,16.81-9.48,0-18.02-3.96-24.11-10.29-2.51.6-5.11.95-7.8.95-18.49,0-33.47-14.98-33.47-33.47,0-.78.06-1.54.12-2.3-13.6-4.25-23.47-16.95-23.47-31.95Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 256.67,
    cy: 1634.89,
    rx: 12.72,
    ry: 5.32,
    transform: "translate(-1207.02 862.65) rotate(-53.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 451.84,
    cy: 1602.2,
    rx: 20.04,
    ry: 30.22,
    transform: "translate(-1031.69 846.98) rotate(-47.27)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 424.48,
    cy: 1603.36,
    rx: 12.02,
    ry: 4.62,
    transform: "translate(-1054.05 851.76) rotate(-48.23)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 450.92,
    cy: 1594.59,
    r: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m296.35,1608.09s17.66,6.93,13.76,25.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m377.38,1605.13s-16.65,24.05-36.38,1.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m396.02,1647.24s-13.94,7.72-25.25-6.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m301.48,1570.33s10.85-2.51,17.78,4.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m313.4,1690.69s15.72-4.62,16.65-17.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1145.67,
    y: 1668.62,
    width: 9.43,
    height: 46.74,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1157.62,
    y: 1666.11,
    width: 9.43,
    height: 46.74,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1192.94,
    y: 1668.94,
    width: 9.43,
    height: 46.74,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1207.4,
    y: 1667.26,
    width: 9.43,
    height: 46.74,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1237.25,1656.37c-.09-1.69-.38-3.35-.85-4.97.85-2.16,1.33-4.51,1.33-6.97,0-10.53-8.54-19.07-19.07-19.07-1.14,0-2.25.12-3.33.31-1.36-9.2-9.26-16.27-18.84-16.27-6.9,0-12.93,3.68-16.27,9.17-2.79-1.59-6-2.52-9.44-2.52-7.96,0-14.77,4.88-17.63,11.81-2.34-1.03-4.93-1.61-7.65-1.61-10.53,0-19.07,8.54-19.07,19.07,0,4.37,1.48,8.38,3.96,11.6-5.55,3.33-9.28,9.39-9.28,16.34,0,10.53,8.54,19.07,19.07,19.07,4.49,0,8.61-1.56,11.87-4.16,3.16,6.15,9.56,10.37,16.95,10.37,6.19,0,11.68-2.97,15.16-7.54.12,0,.24,0,.35,0,.94,0,1.88-.02,2.81-.05,3.32,2.79,7.59,4.48,12.27,4.48,7.12,0,13.32-3.91,16.6-9.7,1.76.54,3.63.83,5.57.83,10.53,0,19.07-8.54,19.07-19.07,0-4.15-1.34-7.98-3.59-11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1180.23,1618.56s-3.24,6.57-1.68,11.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1172.18,1644.52s5.66,12.89,23.58,7.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1138.86,1662.13s-8.8,11,.94,21.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1206.03,1678s14,1.58,17.59-12.19"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1225.6,
    cy: 1630.69,
    rx: 13.12,
    ry: 17.33,
    transform: "translate(-380.61 373.18) rotate(-15.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1211.21,
    cy: 1627.09,
    rx: 5.85,
    ry: 2.57,
    transform: "translate(-816.1 1560.36) rotate(-51.45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1231.04,
    cy: 1616.51,
    rx: 2.66,
    ry: 5.65,
    transform: "translate(-521.56 2644.6) rotate(-83.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 1221.56,
    cy: 1629.18,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 1234.49,
    cy: 1624.53,
    r: 1.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1303.59,
    y: 1707.41,
    width: 8.1,
    height: 40.15,
    rx: 2.05,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1313.85,
    y: 1705.25,
    width: 8.1,
    height: 40.15,
    rx: 2.05,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1346.71,
    y: 1706.6,
    width: 8.1,
    height: 40.15,
    rx: 2.05,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1359.49,
    y: 1707.32,
    width: 8.1,
    height: 40.15,
    rx: 2.05,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1392.61,1688.15c0-8.48-5.42-15.68-12.97-18.39-2.45-6.86-8.61-11.94-16.07-12.82-2.46-7.98-9.89-13.78-18.68-13.78-5.12,0-9.76,1.98-13.24,5.2-2.35-1-4.94-1.56-7.66-1.56-5.23,0-9.97,2.07-13.48,5.42-3.06-1.98-6.69-3.14-10.61-3.14-10.79,0-19.54,8.75-19.54,19.54,0,3.1.74,6.03,2.03,8.64-.18.29-.36.58-.53.87-5.79,3.39-9.68,9.66-9.68,16.85,0,10.54,8.35,19.11,18.79,19.5,2.63,7.68,9.9,13.22,18.48,13.22,4.76,0,9.12-1.71,12.51-4.54.63.07,1.27.12,1.91.17,3.37,5.86,9.69,9.82,16.93,9.82,5.54,0,10.52-2.31,14.08-6.01,1.46.35,2.98.56,4.56.56,10.79,0,19.54-8.75,19.54-19.54,0-.45-.04-.9-.07-1.34,7.94-2.48,13.7-9.89,13.7-18.65Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1389.73,
    cy: 1694.63,
    rx: 3.11,
    ry: 7.43,
    transform: "translate(-737.63 1167.88) rotate(-36.74)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1275.78,
    cy: 1675.55,
    rx: 17.64,
    ry: 11.7,
    transform: "translate(-798.28 1310.37) rotate(-42.73)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1291.75,
    cy: 1676.22,
    rx: 2.7,
    ry: 7.02,
    transform: "translate(-788.3 1286.72) rotate(-41.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 1276.31,
    cy: 1672.22,
    r: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1358.28,1674.3s-10.31,4.05-8.04,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1305.48,1702.19s9.72,14.04,21.24,1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1326.36,1680.41s3.87-8.46-5.04-14.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1363.57,1656.94s-6.33-1.46-10.38,2.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1356.61,1727.22s-9.18-2.7-9.72-10.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 2383.97,
    y: 1571.59,
    width: 13.87,
    height: 68.76,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 2401.55,
    y: 1567.89,
    width: 13.87,
    height: 68.76,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 2457.82,
    y: 1570.2,
    width: 13.87,
    height: 68.76,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 2479.71,
    y: 1571.44,
    width: 13.87,
    height: 68.76,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m2519.42,1548.19c0-9.2-4.22-17.4-10.82-22.8.19-1.35.32-2.73.32-4.13,0-16.26-13.18-29.45-29.45-29.45-7.24,0-13.87,2.63-18.99,6.96-5.05-4.06-11.46-6.51-18.44-6.51-2.33,0-4.59.3-6.76.81-5.17-4.48-11.89-7.2-19.26-7.2-7.88,0-15.03,3.12-20.31,8.16-4.61-2.99-10.09-4.74-15.98-4.74-16.26,0-29.45,13.18-29.45,29.45,0,4.68,1.12,9.08,3.06,13.01-.27.43-.54.87-.8,1.31-8.72,5.11-14.59,14.56-14.59,25.39,0,15.88,12.58,28.79,28.31,29.39,3.96,11.58,14.92,19.92,27.84,19.92,7.17,0,13.74-2.57,18.85-6.83.95.1,1.92.18,2.88.26,5.08,8.83,14.59,14.79,25.52,14.79,8.34,0,15.86-3.48,21.21-9.05,2.21.53,4.5.84,6.86.84,16.26,0,29.45-13.18,29.45-29.45,0-.68-.06-1.35-.1-2.02,11.96-3.74,20.65-14.91,20.65-28.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m2406.94,1517.33s16.65,24.05,36.38,1.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m2400.16,1570.05s6.63-14.49-8.63-24.67"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 2344.19,
    cy: 1528.43,
    rx: 25.49,
    ry: 19.3,
    transform: "translate(260.65 3396.63) rotate(-74.99)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 2365.36,
    cy: 1523.13,
    rx: 3.78,
    ry: 8.61,
    transform: "translate(-433.72 1806) rotate(-38.55)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 2336.19,
    cy: 1507.58,
    rx: 8.31,
    ry: 3.92,
    transform: "translate(-164.08 291.35) rotate(-6.89)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 2343.97,
    cy: 1526.21,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 2329.57,
    cy: 1521.22,
    r: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m2465.52,1526.58s8.32,18.96,34.69,11.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m2452.37,1569.46s-17.66,6.93-13.76,25.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1073.93,
    y: 520.38,
    width: 758.23,
    height: 926.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1486.2,
    y1: 599.14,
    x2: 1720.71,
    y2: 599.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1486.2,
    y1: 667.52,
    x2: 1719.6,
    y2: 667.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1486.2,
    y1: 735.89,
    x2: 1721.04,
    y2: 735.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1486.2,
    y1: 804.27,
    x2: 1718.88,
    y2: 804.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1486.2,
    y1: 872.65,
    x2: 1718.88,
    y2: 872.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1486.2,
    y1: 941.02,
    x2: 1719.6,
    y2: 941.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1486.2,
    y1: 1009.4,
    x2: 1720.32,
    y2: 1009.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1486.2,
    y1: 1085.37,
    x2: 1719.6,
    y2: 1085.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1486.2,
    y1: 1153.75,
    x2: 1721.76,
    y2: 1153.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1486.2,
    y1: 1222.12,
    x2: 1719.96,
    y2: 1222.12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(1387.69 601.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Date:")), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(1285.9 668.15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 18.97,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.97,
    y: 0
  }, "y of "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 90.78,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 115.1,
    y: 0
  }, "eek:")), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(1372.53 738.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Floss?")), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(1329.94 803.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 16.27,
    y: 0
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.16,
    y: 0
  }, "ercise?")), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(1272.79 870.62)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.32,
    y: 0
  }, "ater In"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 110.44,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 121.04,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 137.41,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 153.04,
    y: 0
  }, "e?")), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(1343.66 938.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Alcohol?")), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(1367.89 1006.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sleep?")), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(1247.61 1080.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sh"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 33.46,
    y: 0
  }, "ow"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 70,
    y: 0
  }, "er Length?")), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(1289.7 1148.18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Phone Time?")), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(1222.24 1215.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Secret "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 92.32,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 110,
    y: 0
  }, "ass"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 155.97,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 176.31,
    y: 0
  }, "ord?")), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1109.24,362.23c5.66,3,10.04,7.21,13.14,12.63,3.1,5.42,4.66,11.68,4.66,18.77s-1.55,13.27-4.66,18.72c-3.1,5.46-7.5,9.68-13.2,12.68-5.7,3-12.29,4.5-19.79,4.5h-26.9v-71.81h26.9c7.57,0,14.18,1.5,19.85,4.5Zm-5.52,46.75c3.68-3.61,5.52-8.73,5.52-15.34s-1.84-11.76-5.52-15.45-8.83-5.52-15.45-5.52h-8.29v41.74h8.29c6.61,0,11.76-1.81,15.45-5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1136.71,385.45c2.22-4.43,5.23-7.84,9.05-10.23,3.82-2.39,8.08-3.58,12.79-3.58,4.02,0,7.55.82,10.59,2.46,3.03,1.64,5.37,3.79,7.01,6.44v-8.08h17.49v57.08h-17.49v-8.08c-1.71,2.66-4.08,4.81-7.11,6.44-3.04,1.64-6.56,2.46-10.59,2.46-4.64,0-8.87-1.21-12.68-3.63-3.82-2.42-6.84-5.86-9.05-10.33-2.22-4.47-3.32-9.63-3.32-15.5s1.11-11.01,3.32-15.45Zm35.8,5.22c-2.42-2.52-5.37-3.79-8.85-3.79s-6.43,1.25-8.85,3.73c-2.42,2.49-3.63,5.92-3.63,10.28s1.21,7.83,3.63,10.38c2.42,2.56,5.37,3.84,8.85,3.84s6.43-1.26,8.85-3.79c2.42-2.52,3.63-5.97,3.63-10.33s-1.21-7.81-3.63-10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1207.6,363.81c-1.94-1.81-2.92-4.04-2.92-6.7s.97-5,2.92-6.8c1.94-1.81,4.45-2.71,7.52-2.71s5.47.91,7.42,2.71c1.94,1.81,2.92,4.08,2.92,6.8s-.97,4.89-2.92,6.7c-1.94,1.81-4.42,2.71-7.42,2.71s-5.58-.9-7.52-2.71Zm16.21,8.64v57.08h-17.49v-57.08h17.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1253.99,353.84v75.7h-17.49v-75.7h17.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1324.98,372.46l-35.8,84.19h-18.82l13.09-29.05-23.22-55.14h19.54l13.2,35.7,13.09-35.7h18.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1354.65,374.55c3.07-5.56,7.35-9.89,12.84-12.99,5.49-3.1,11.71-4.65,18.67-4.65,8.52,0,15.82,2.25,21.89,6.75,6.07,4.5,10.13,10.64,12.17,18.41h-19.23c-1.43-3-3.46-5.28-6.09-6.85-2.63-1.57-5.61-2.35-8.95-2.35-5.39,0-9.75,1.88-13.09,5.63-3.34,3.75-5.01,8.76-5.01,15.04s1.67,11.29,5.01,15.04c3.34,3.75,7.71,5.63,13.09,5.63,3.34,0,6.33-.78,8.95-2.35,2.62-1.57,4.65-3.85,6.09-6.85h19.23c-2.05,7.77-6.1,13.9-12.17,18.36-6.07,4.47-13.37,6.7-21.89,6.7-6.96,0-13.18-1.55-18.67-4.65-5.49-3.1-9.77-7.42-12.84-12.94-3.07-5.52-4.6-11.83-4.6-18.92s1.53-13.42,4.6-18.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1481.8,378.34c3.95,4.33,5.93,10.28,5.93,17.85v33.35h-17.39v-31c0-3.82-.99-6.79-2.97-8.9-1.98-2.11-4.64-3.17-7.98-3.17s-6,1.06-7.98,3.17c-1.98,2.11-2.97,5.08-2.97,8.9v31h-17.49v-75.7h17.49v26.29c1.77-2.52,4.19-4.53,7.26-6.04,3.07-1.5,6.51-2.25,10.33-2.25,6.55,0,11.8,2.17,15.75,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1553.41,405.19h-39.59c.27,3.55,1.41,6.26,3.43,8.13,2.01,1.88,4.48,2.81,7.42,2.81,4.36,0,7.4-1.84,9.1-5.52h18.62c-.96,3.75-2.68,7.13-5.17,10.13-2.49,3-5.61,5.35-9.36,7.06-3.75,1.71-7.95,2.56-12.58,2.56-5.59,0-10.57-1.19-14.94-3.58-4.37-2.39-7.77-5.8-10.23-10.23-2.46-4.43-3.68-9.62-3.68-15.55s1.21-11.11,3.63-15.55c2.42-4.43,5.81-7.84,10.18-10.23,4.36-2.39,9.38-3.58,15.04-3.58s10.43,1.16,14.73,3.48c4.3,2.32,7.65,5.63,10.08,9.92,2.42,4.3,3.63,9.31,3.63,15.04,0,1.64-.1,3.34-.31,5.11Zm-17.59-9.72c0-3-1.02-5.39-3.07-7.16-2.05-1.77-4.6-2.66-7.67-2.66s-5.41.85-7.42,2.56c-2.01,1.71-3.26,4.13-3.73,7.26h21.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1563.08,385.45c2.42-4.43,5.8-7.84,10.13-10.23,4.33-2.39,9.29-3.58,14.88-3.58,7.16,0,13.15,1.88,17.95,5.63,4.81,3.75,7.96,9.04,9.46,15.86h-18.62c-1.57-4.36-4.6-6.55-9.1-6.55-3.21,0-5.76,1.25-7.67,3.73-1.91,2.49-2.86,6.05-2.86,10.69s.95,8.2,2.86,10.69c1.91,2.49,4.47,3.73,7.67,3.73,4.5,0,7.54-2.18,9.1-6.55h18.62c-1.5,6.68-4.67,11.94-9.51,15.75-4.84,3.82-10.81,5.73-17.9,5.73-5.59,0-10.55-1.19-14.88-3.58-4.33-2.39-7.71-5.8-10.13-10.23-2.42-4.43-3.63-9.62-3.63-15.55s1.21-11.11,3.63-15.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1659.69,429.54l-17.39-23.94v23.94h-17.49v-75.7h17.49v41.84l17.29-23.22h21.58l-23.73,28.64,23.94,28.44h-21.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1705.52,353.84v75.7h-17.49v-75.7h17.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1719.48,363.81c-1.94-1.81-2.92-4.04-2.92-6.7s.97-5,2.92-6.8c1.94-1.81,4.45-2.71,7.52-2.71s5.47.91,7.42,2.71c1.94,1.81,2.92,4.08,2.92,6.8s-.97,4.89-2.92,6.7c-1.94,1.81-4.42,2.71-7.42,2.71s-5.58-.9-7.52-2.71Zm16.21,8.64v57.08h-17.49v-57.08h17.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1758.3,427.8c-3.89-1.7-6.96-4.04-9.21-7.01-2.25-2.97-3.51-6.29-3.79-9.97h17.29c.21,1.98,1.12,3.58,2.76,4.81s3.65,1.84,6.04,1.84c2.18,0,3.87-.42,5.06-1.28,1.19-.85,1.79-1.96,1.79-3.32,0-1.64-.85-2.85-2.56-3.63-1.71-.78-4.47-1.65-8.29-2.61-4.09-.95-7.5-1.96-10.23-3.02-2.73-1.06-5.08-2.73-7.06-5.01-1.98-2.28-2.97-5.37-2.97-9.26,0-3.27.9-6.26,2.71-8.95,1.81-2.69,4.47-4.82,7.98-6.39,3.51-1.57,7.69-2.35,12.53-2.35,7.16,0,12.8,1.77,16.93,5.32,4.13,3.55,6.5,8.25,7.11,14.12h-16.16c-.27-1.98-1.14-3.55-2.61-4.71-1.47-1.16-3.39-1.74-5.78-1.74-2.05,0-3.62.39-4.71,1.18-1.09.78-1.64,1.86-1.64,3.22,0,1.64.87,2.87,2.61,3.68s4.45,1.64,8.13,2.46c4.23,1.09,7.67,2.17,10.33,3.22,2.66,1.06,4.99,2.76,7.01,5.12,2.01,2.35,3.05,5.51,3.12,9.46,0,3.34-.94,6.33-2.81,8.95-1.88,2.63-4.57,4.69-8.08,6.19-3.51,1.5-7.59,2.25-12.22,2.25-4.98,0-9.41-.85-13.3-2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1837.28,414.71v14.83h-8.9c-6.34,0-11.29-1.55-14.83-4.65-3.55-3.1-5.32-8.17-5.32-15.19v-22.71h-6.96v-14.53h6.96v-13.91h17.49v13.91h11.46v14.53h-11.46v22.92c0,1.71.41,2.93,1.23,3.68.82.75,2.18,1.12,4.09,1.12h6.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1158.62,
    y: 1294.91,
    width: 570.83,
    height: 65.56
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(1389.27 1335.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SUBMIT")), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 530.6,
    cy: 465.61,
    r: 131.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m455.54,454.35v-6.27h10.93v28.8h-7.02v-22.53h-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m472.02,460.09c-.75-.7-1.12-1.56-1.12-2.58s.38-1.93,1.12-2.64c.75-.71,1.72-1.07,2.9-1.07s2.11.36,2.86,1.07c.75.71,1.12,1.59,1.12,2.64s-.38,1.89-1.12,2.58c-.75.7-1.7,1.04-2.86,1.04s-2.15-.35-2.9-1.04Zm0,16.06c-.75-.7-1.12-1.56-1.12-2.58s.38-1.93,1.12-2.64c.75-.71,1.72-1.07,2.9-1.07s2.11.36,2.86,1.07c.75.71,1.12,1.59,1.12,2.64s-.38,1.89-1.12,2.58c-.75.7-1.7,1.04-2.86,1.04s-2.15-.35-2.9-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m485.29,449.7c1.74-1.53,4.09-2.29,7.06-2.29,1.97,0,3.66.34,5.07,1.03,1.41.68,2.47,1.62,3.2,2.8s1.08,2.51,1.08,3.99c0,1.74-.43,3.15-1.3,4.24-.87,1.09-1.88,1.83-3.04,2.23v.16c1.5.5,2.68,1.33,3.55,2.49.87,1.16,1.3,2.64,1.3,4.46,0,1.63-.37,3.07-1.12,4.32s-1.84,2.23-3.27,2.94c-1.43.71-3.14,1.06-5.11,1.06-3.16,0-5.67-.78-7.56-2.33s-2.87-3.89-2.98-7.02h6.55c.03,1.16.35,2.07.99,2.74.63.67,1.55,1.01,2.76,1.01,1.03,0,1.82-.3,2.39-.89s.85-1.37.85-2.35c0-1.26-.4-2.18-1.2-2.74-.8-.57-2.08-.85-3.85-.85h-1.26v-5.48h1.26c1.34,0,2.43-.23,3.26-.69.83-.46,1.24-1.28,1.24-2.47,0-.95-.26-1.68-.79-2.21s-1.25-.79-2.17-.79c-1,0-1.74.3-2.23.91-.49.61-.77,1.36-.85,2.25h-6.59c.1-2.81,1.03-4.98,2.76-6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m508.79,451.39c1.75-2.6,4.57-3.91,8.46-3.91s6.71,1.3,8.46,3.91c1.75,2.6,2.62,6.17,2.62,10.69s-.87,8.17-2.62,10.77c-1.75,2.6-4.57,3.91-8.46,3.91s-6.71-1.3-8.46-3.91c-1.75-2.6-2.62-6.19-2.62-10.77s.87-8.09,2.62-10.69Zm12.05,4.56c-.58-1.43-1.78-2.15-3.59-2.15s-3.01.72-3.59,2.15c-.58,1.43-.87,3.48-.87,6.14,0,1.79.1,3.27.32,4.44.21,1.17.64,2.12,1.28,2.84.64.72,1.6,1.08,2.86,1.08s2.22-.36,2.86-1.08c.64-.72,1.07-1.67,1.28-2.84.21-1.17.32-2.65.32-4.44,0-2.66-.29-4.7-.87-6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m550.39,455.5c1.16-.63,2.51-.95,4.06-.95,1.82,0,3.46.46,4.93,1.38,1.47.92,2.64,2.24,3.49,3.95.85,1.71,1.28,3.7,1.28,5.96s-.43,4.25-1.28,5.98c-.86,1.72-2.02,3.05-3.49,3.99-1.47.93-3.12,1.4-4.93,1.4-1.53,0-2.87-.32-4.04-.95-1.17-.63-2.08-1.45-2.74-2.45v13.57h-6.75v-32.51h6.75v3.12c.66-1.03,1.56-1.85,2.72-2.49Zm5.5,6.37c-.93-.96-2.08-1.44-3.45-1.44s-2.48.49-3.41,1.46c-.93.97-1.4,2.3-1.4,3.99s.47,3.01,1.4,3.98c.93.97,2.07,1.46,3.41,1.46s2.49-.49,3.43-1.48c.95-.99,1.42-2.32,1.42-4s-.47-3-1.4-3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m602.34,457.11c1.62,1.66,2.43,3.96,2.43,6.91v12.86h-6.71v-11.96c0-1.42-.38-2.52-1.12-3.29-.75-.78-1.78-1.16-3.1-1.16s-2.35.39-3.1,1.16c-.75.78-1.12,1.88-1.12,3.29v11.96h-6.71v-11.96c0-1.42-.38-2.52-1.12-3.29-.75-.78-1.78-1.16-3.1-1.16s-2.35.39-3.1,1.16c-.75.78-1.12,1.88-1.12,3.29v11.96h-6.75v-22.02h6.75v2.76c.68-.92,1.58-1.65,2.68-2.19,1.1-.54,2.35-.81,3.75-.81,1.66,0,3.14.36,4.44,1.07,1.3.71,2.32,1.72,3.06,3.04.76-1.21,1.8-2.2,3.12-2.96,1.31-.76,2.75-1.14,4.3-1.14,2.74,0,4.91.83,6.53,2.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 101.45,
    y: 178.35,
    width: 2797.11,
    height: 1643.3,
    rx: 39.9,
    ry: 39.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyChecklistHero5);
export default __webpack_public_path__ + "static/media/daily_checklist_hero5.adfa7f1737cccd5359202c96d4268601.svg";
export { ForwardRef as ReactComponent };